import { render, staticRenderFns } from "./abnormalstatistics.vue?vue&type=template&id=fda9717c&scoped=true"
import script from "./abnormalstatistics.vue?vue&type=script&lang=js"
export * from "./abnormalstatistics.vue?vue&type=script&lang=js"
import style0 from "./abnormalstatistics.vue?vue&type=style&index=0&id=fda9717c&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda9717c",
  null
  
)

export default component.exports